import Licensing from './Licensing.vue';
// import disable from './disable.vue';

export default Licensing;
